import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { IOnboardingEditItem, ISyncOnboarding } from '../../../fi-onboarding';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { FiOnboardingService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding.service';

@Component({
    selector: 'fi-connect-onboarding-item-select',
    templateUrl: './fi-connect-onboarding-item-select.component.html',
    styleUrls: ['./fi-connect-onboarding-item-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-connect-onboarding-item-select' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiConnectOnboardingItemSelectComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiConnectOnboardingItemSelectComponent,
            multi: true,
        },
    ],
})
export class FiConnectOnboardingItemSelectComponent
    extends ControlValueAccessorValidatorBase<number>
    implements OnInit
{
    @Input({ required: true }) syncReadyOnboardings: INameIdObj[] = [];
    @Input() isMasterOnboarding = false;
    @Output() onboardingChange = new EventEmitter<IOnboardingEditItem>();

    constructor(
        private injector: Injector,
        private fiOnboardingService: FiOnboardingService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.loadOnboarding(this.ngModel);
    }

    private _currentOnboarding$ = new BehaviorSubject<IOnboardingEditItem>(null);
    get currentOnboarding$(): Observable<IOnboardingEditItem> {
        return this._currentOnboarding$.asObservable();
    }

    /*protected getCurrentOnboarding() {
        return this.syncReadyOnboardings.find((onboarding) => onboarding.Id === this.ngModel);
    }*/

    protected onSelectedOnboardingIdChanged(selectedOnboardingId: number) {
        this.loadOnboarding(selectedOnboardingId);
        this.doPropagateChanges();
    }

    private loadOnboarding(selectedOnboardingId: number) {
        if (selectedOnboardingId) {
            this._currentOnboarding$.next(undefined);
            this.fiOnboardingService.getOnboarding(selectedOnboardingId, true).then((onboarding) => {
                this._currentOnboarding$.next(onboarding);
                this.onboardingChange.emit(onboarding);
            });
        }
    }
}
